import { routes } from '~constants/routes';

import { RegisterInbound, RegisterOutbound } from './enums/register';

export const getRegisterInboundByPath = (pathname: string) => {
	if (pathname === routes.generate.character) {
		return RegisterInbound.NavigationClickGeneratorLink;
	}

	if (
		pathname.startsWith(routes.generate.images.home) ||
		pathname.startsWith(routes.generate.videos.home)
	) {
		return RegisterInbound.NavigationClickGeneratorLink;
	}

	return undefined;
};

export const getRegisterOutboundByPath = (pathname: string) => {
	if (pathname === routes.generate.character) {
		return RegisterOutbound.GeneratorBot;
	}

	if (
		pathname.startsWith(routes.generate.images.home) ||
		pathname.startsWith(routes.generate.videos.home)
	) {
		return RegisterOutbound.GeneratorImages;
	}

	return undefined;
};
